export default __webpack_public_path__ + "static/media/termlife_file_icon_customer.ef8e607e.svg";